module.exports = __webpack_public_path__ + "static/media/content_copy.72dd793a.svg";